module.exports = __webpack_public_path__ + "img/back.91c5474c.jpeg";